var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconsChart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003A5D",
    d: "M7 21a1 1 0 01-2 0v-8a1 1 0 012 0v8zm6 0a1 1 0 01-2 0V3a1 1 0 012 0v18zm6 0a1 1 0 01-2 0V9a1 1 0 012 0v12z"
  }))));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgZmlsbC1ydWxlPSJub256ZXJvIj4KICAgICAgICAgICAgPGc+CiAgICAgICAgICAgICAgICA8cGF0aCBkPSJNMCAwSDI0VjI0SDB6Ii8+CiAgICAgICAgICAgICAgICA8cGF0aCBmaWxsPSIjMDAzQTVEIiBkPSJNNyAyMWMwIC41NTItLjQ0OCAxLTEgMXMtMS0uNDQ4LTEtMXYtOGMwLS41NTIuNDQ4LTEgMS0xczEgLjQ0OCAxIDF2OHptNiAwYzAgLjU1Mi0uNDQ4IDEtMSAxcy0xLS40NDgtMS0xVjNjMC0uNTUyLjQ0OC0xIDEtMXMxIC40NDggMSAxdjE4em02IDBjMCAuNTUyLS40NDggMS0xIDFzLTEtLjQ0OC0xLTFWOWMwLS41NTIuNDQ4LTEgMS0xczEgLjQ0OCAxIDF2MTJ6Ii8+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPgo=";
export { SvgIconsChart as ReactComponent };